import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'checkbox'];

  confirm() {
    this.buttonTarget.disabled = !this.checkboxTarget.checked;
  }
}
